<template>
  <div class="service-form-success">
    <div class="service-form-success-icon">
      <z-icon class-prefix="zziconfont" name="close-text" />
    </div>
    <p>该订单您已提交过，无法再次申请。</p>
  </div>
</template>

<script>
import { Icon } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'
import { hideShareButton, closeZljRefresh } from '../../../lib/utils'

export default {
  name: 'serviceFormSuccess',
  components: {
    'z-icon': Icon
  },
  data() {
    return {
    }
  },
  created() {
    hideShareButton()
    closeZljRefresh()
    native.setTitle({
      title: '自助提交'
    })
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
  @import "../../../assets/css/base.less";
  .service-form-success {
    padding-top: 200px;
    &-icon {
      width: 80px;
      margin: 0 auto;
      font-size: 80px;
      color: red;
    }
    p {
      text-align: center;
      font-size: 32px;
      margin-bottom: 8px;
    }
  }
</style>
